import React from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "../../components/layout/DashboardLayout";

const NAV = [
  { to: "/admin",           label: "Dashboard",    icon: "⬛", end: true },
  { to: "/admin/zones",     label: "Zones & Stations", icon: "🗂️" },
  { to: "/admin/staff",     label: "Staff",        icon: "👤" },
  { to: "/admin/settings",  label: "Settings",     icon: "⚙️" },
  { to: "/admin/display",   label: "Display Board", icon: "📺" },
  { to: "/admin/audio",     label: "Audio",        icon: "🔊" },
  { to: "/admin/reports",   label: "Reports",      icon: "📊" },
];

export default function FacilityAdminLayout() {
  return (
    <DashboardLayout navItems={NAV} sectionLabel="Facility Admin">
      <Outlet />
    </DashboardLayout>
  );
}
